import { ModelBase } from '../../core/model/model-base';
import { LicenseTypeKind } from './const/enum';

export class License extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.licenseType = dataContext.licenseType;
      this.validTo = dataContext.validTo;
    }
  }

  licenseType: LicenseTypeKind;
  validTo?: Date;
}

export class LicenseLimitComparison extends ModelBase {
  dwellingLimit?: number;
  parkingLimit?: number;
  otherObjectLimit?: number;
  premisesSqmLimit?: number;
  dwellingLevel: number;
  parkingLevel: number;
  otherObjectLevel: number;
  premisesSqmLevel: number;

  constructor(data?: any) {
    super();
    this.dwellingLimit = data?.dwellingLimit ?? 0;
    this.parkingLimit = data?.parkingLimit ?? 0;
    this.otherObjectLimit = data?.otherObjectLimit ?? 0;
    this.premisesSqmLimit = data?.premisesSqmLimit ?? 0;
    this.dwellingLevel = data?.dwellingLevel ?? 0;
    this.parkingLevel = data?.parkingLevel ?? 0;
    this.otherObjectLevel = data?.otherObjectLevel ?? 0;
    this.premisesSqmLevel = data?.premisesSqmLevel ?? 0;
  }
}
